<template>

    <div> UNUSED!</div>
<!--    <div class="portfolio-options">-->
<!--        <design-2021-apprentice-multistep-form-wizard-form-header-component title="Opties"-->
<!--                                                                            :description="description">-->
<!--        </design-2021-apprentice-multistep-form-wizard-form-header-component>-->

<!--        <b-list-group class="portfolio-options">-->
<!--            <b-list-group-item class="portfolio-option-item"-->
<!--                               v-for="(option, needle) in options"-->
<!--                               :key="`${option.key}`">-->
<!--                <span class="option-title">{{option.label}}</span>-->
<!--                <span class="status">-->
<!--                    <b-form-checkbox-->
<!--                        v-model="option.enabled"-->
<!--                        name="portfolio-options-toggle"-->
<!--                        switch-->
<!--                        @change="updateOptions">-->
<!--                    </b-form-checkbox>-->
<!--                </span>-->
<!--            </b-list-group-item>-->
<!--        </b-list-group>-->
<!--    </div>-->
</template>

<script>
export default {
    name: "design-2021-apprentice-portfolio-wizard-fourth-step-component",
    props: {
        value: Array,
    },
    data() {
        return {
            description: 'Schakel gewenste opties aan voor deze project',
            options: this.value ? this.value : {},
        }
    },

    methods: {
        updateOptions() {

        }
    }
}
</script>

<style scoped lang="scss">
    .portfolio-options {

    }

    .list-group-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: none;
    }

    .option-title {
        font-weight: $font-weight-bold;
        color: $text-muted-color;
    }

    .portfolio-option-item {
        padding: map-get($grid-gutter-spacing, 'eight') 0;
    }

    @media(min-width: map-get($grid-breakpoints, 'xl')){
        .portfolio-options {
            max-width: 45%;
        }
    }
</style>
